import './blur.css'
const Blur = () => {
    return (
        <div className='blur-container' />
    )
}
export default Blur